<template>
    <div class="not-found">
        <default :title="title" :wrap-content="true">
            <div slot="content" class="content">
                <div class="error-image-con">
                    <div class="img-wrap">
                        <img class="img-responsive" :src="`${cdn_url}/images/404.png`" alt="404">
                        <div class="text-con">
                            <h3>{{ 'Error' | translate }}</h3>
                            <h5>{{ 'page not found' | translate }}</h5>
                        </div>
                    </div>
                    <button class="btn btn-black" @click="$router.push({name: 'home'})">
                        {{ 'Back to homepage' | translate }}
                    </button>
                </div>
            </div>
        </default>
    </div>
</template>

<script>
	import Default from '@theme-views/public/layouts/Default'
	
	export default {
        name: 'not-found',
        data() {
            return {
                cdn_url: window.APP_CONFIG.CDN_URL,
            }
        },
        computed: {
            showDesktop() {
                return this.$root.$children[0].width > 1199
            },
            title() {
                return (this.showDesktop) ? '' : `404 ${this.$t('page not found')}`
            }
        },
        components: {
        	Default
        }
    }
</script>

<style lang="scss">
.not-found {
    .error-image-con {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 88px 0;
        > .img-wrap {
            max-width: 618px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            margin-bottom: 80px;
            position: relative;
            .text-con {
                position: absolute;
                padding-left: 280px;
                padding-top: 52px;
                width: 100%;
                > h3, > h5 {
                    font-size: 40px !important;
                    color: #1a3899;
                    font-weight: bold;
                    white-space: nowrap;
                    margin-bottom: 0;
                }
                > h5 {
                    top: 90px;
                    color: #8f9dc9;
                    font-weight: normal;
                }
            }
        }
        .btn-black {
            max-width: 320px;
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            line-height: 1;
            padding: 14px;
        }
    }

    .mobile {
        > .con-wrapper {
            padding-top: 0 !important;
        }
        .error-image-con {
            @media (max-width: 950px) {
                > .img-wrap {
                    .text-con {
                        padding-top: 60px;
                        > h3, > h5 {
                            font-size: 30px !important;
                        }
                    }
                }
            }
            @media (max-width: 650px) {
                padding: 45px 0;
                > .img-wrap {
                    margin-bottom: 60px;
                    .text-con {
                        padding-top: 62px;
                        padding-left: 45%;
                        > h3, > h5 {
                            font-size: 26px !important;
                        }
                    }
                }
            }
            @media (max-width: 575px) {
                > .img-wrap {
                    .text-con {
                        padding-top: 48px;
                        > h3 {
                            font-size: 24px !important;
                        }
                        > h5 {
                            font-size: 20px !important;
                        }
                    }
                }
            }
            @media (max-width: 400px) {
                > .img-wrap {
                    .text-con {
                        padding-top: 30px;
                        > h3 {
                            font-size: 20px !important;
                        }
                        > h5 {
                            font-size: 14px !important;
                        }
                    }
                }
            }
        }
    }
}
</style>